import { jsx as _jsx } from "react/jsx-runtime";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const LoadingSpinner = ({ size = 'default', tip, spinning = true, children, className, style, }) => {
    const antIcon = _jsx(LoadingOutlined, { style: { fontSize: size === 'large' ? 24 : size === 'small' ? 14 : 18 }, spin: true });
    if (children) {
        return (_jsx(Spin, { spinning: spinning, tip: tip, indicator: antIcon, size: size, className: className, style: style, children: children }));
    }
    return (_jsx("div", { className: className, style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100px',
            ...style,
        }, children: _jsx(Spin, { spinning: spinning, tip: tip, indicator: antIcon, size: size }) }));
};
export default LoadingSpinner;
